import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import { Alert } from "reactstrap";
import Select from "react-select";
import { addNewPayment } from "store/Payment/actions";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import {
  getApprovedLabs,
  updateMembershipStatus,
} from "store/registration-admin/actions";
import { getParticipantSchemelist } from "store/Payment/actions";
import { getcyclelist } from "store/cycle/actions";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Import Breadcrumb & Validation
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getAllLabs,
  updateAllLabs,
  approveUnapproveLab,
} from "store/registration-admin/actions";

import ApproveUnapproveModal from "components/Common/ApproveUnapproveModal";
import "assets/scss/table.scss";

class AllParticipantsPaymentPage extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.handleSchemeChange = this.handleSchemeChange.bind(this);

    const selectedParticipant =
      (this.props.location &&
        this.props.location.state &&
        this.props.location.state.selectedParticipant) ||
      {};
    console.log("tt", selectedParticipant);
    this.state = {
      selectedParticipant,
      showModal: false,
      editModal: false,
      AllLabs: [],
      approvedLabs: [],
      ListCity: [],
      ListDistrict: [],
      ListProvince: [],
      paymentType: "new", // default page
      ListDesignation: [],
      CycleList: [],
      selectedScheme: null,
      id: "",
      btnText: "Copy",
      isPaymentModalOpen: false, // not used anymore but kept for safety
      isMembershipModalOpen: false,
      organization_name: "",
      isApproved: false,
      unapprovedModal: false,
      tooltipContent: ["Worst", "Bad", "Average", "Good", "Excellent"],
      filteredLabs: [],
      cityOptions: [],
      districtOptions: [],
      selectedParticipantType: "All Participant",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      successMessage: "",
    };

    console.log(
      "Initialized user_id:",
      localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "No authUser found in localStorage"
    );

    this.toggle = this.toggle.bind(this);
    this.handleApprovedEvent = this.handleApprovedEvent.bind(this);
    this.togglePatientModal = this.togglePatientModal.bind(this);
    this.toggleMarketerModal = this.toggleMarketerModal.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleParticipantTypeChange =
      this.handleParticipantTypeChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  handleParticipantTypeChange(event) {
    const selectedParticipantType = event.target.value;
    console.log("Selected Participant Type:", selectedParticipantType);

    this.setState({ selectedParticipantType }, () => {
      console.log(
        "Updated selectedParticipantType in state:",
        this.state.selectedParticipantType
      );
      this.applyFilters();
    });
  }

  handleSchemeChange = event => {
    const selectedScheme = event.target.value;
    console.log("Scheme selected:", selectedScheme);

    this.setState({ selectedScheme }, () => {
      this.applyFilters();
    });
  };
  getCycleBgColor = reportstatus => {
    switch ((reportstatus || "").toLowerCase()) {
      case "previous":
        return "#fff3cd"; // light yellow
      case "old":
        return "#e2e3e5"; // light gray
      case "new":
        return "#d1e7dd"; // light green
      default:
        return "transparent";
    }
  };

  applyFilters = () => {
    const {
      AllLabs,
      selectedParticipantType,
      selectedScheme,
      organization_name,
    } = this.state;

    console.log("Filtering with:", {
      selectedParticipantType,
      selectedScheme,
      AllLabs,
    });

    const filteredData = AllLabs.filter(lab => {
      const membershipStatus = lab.membership_status?.trim().toLowerCase();
      const membershipDetail = lab.membership_status_detail
        ? lab.membership_status_detail.trim().toLowerCase()
        : "";

      console.log("Lab Data:", {
        id: lab.id,
        membershipStatus,
        membershipDetail,
      });

      let matchesParticipantType = false;

      if (selectedParticipantType === "All Participant") {
        matchesParticipantType = true;
      } else if (selectedParticipantType === "Approved Participant") {
        matchesParticipantType =
          membershipStatus === "active" || membershipDetail === "active";
      } else if (selectedParticipantType === "Pending Participant") {
        matchesParticipantType = membershipStatus === "pending";
      } else if (selectedParticipantType === "Unapproved Participant") {
        matchesParticipantType = membershipStatus === "inactive";
      } else if (selectedParticipantType === "Suspended Participant") {
        matchesParticipantType = membershipStatus === "suspended";
      } else if (selectedParticipantType === "New Register") {
        matchesParticipantType = membershipStatus === "new register";
      }

      console.log(
        `Lab ${lab.id} matchesParticipantType:`,
        matchesParticipantType
      );

      const matchesScheme =
        !selectedScheme ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            scheme => scheme.scheme_id?.toString() === selectedScheme
          ));

      console.log(`Lab ${lab.id} matchesScheme:`, matchesScheme);

      return matchesParticipantType && matchesScheme;
    });

    if (selectedParticipantType === "Pending Participant") {
      this.props.history.push(`/${organization_name}/pending-participant`);
      return;
    }

    this.setState({ filteredLabs: filteredData }, () => {
      console.log("Updated filteredLabs:", this.state.filteredLabs);
    });
  };

  applyFiltersFromQueryParams = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const filterType = queryParams.get("filterType");
    const filterValue = queryParams.get("filterValue");

    console.log("Applying filters from query params:", {
      filterType,
      filterValue,
    });

    if (filterType && filterValue) {
      this.setState(
        {
          selectedParticipantType: filterValue,
        },
        () => {
          this.applyFilters();
        }
      );
    }
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };

  togglePaymentModal = () => {
    this.setState(
      prevState => ({
        isPaymentModalOpen: !prevState.isPaymentModalOpen,
      }),
      () => {
        console.log("Modal Toggled, New State:", this.state.isPaymentModalOpen);
      }
    );
    if (this.props.toggle) {
      this.props.toggle();
    }
  };

  handleEditSubmit(values) {
    console.log("Form values:", values);

    const updatedData = {
      id: values.id,
      name: values.name,
      email: values.email,
      address: values.address,
      province: values.province,
      designation: values.designation,
      shipping_address: values.shipping_address,
      billing_address: values.billing_address,
      marketer_name: values.marketer_name,
      city: values.city,
      district: values.district,
      lab_staff_name: values.lab_staff_name,
      designation: values.designation,
      email_participant: values.email_participant,
      landline_registered_by: values.landline_registered_by,
      payment_status: values.payment_status,
      payment_settlement: values.payment_settlement,
    };

    this.props.onupdateAllLabs(updatedData);

    this.setState({ successMessage: "Participant updated successfully" });

    setTimeout(() => {
      this.setState({ editModal: false, successMessage: "" });
    }, 2000);
  }

  componentDidMount() {
    console.log("Fetching data...", this.state.selectedParticipant);
    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) {
      console.error("User ID is missing. Cannot proceed with API calls.");
      return;
    }

    console.log("Retrieved user_id:", user_id);

    this.setState({ user_id }, () => {
      const { organization_name } = this.props.match.params || {};
      console.log("organization_name from props:", organization_name);

      if (organization_name) {
        this.setState({ organization_name }, () => {
          console.log("Organization name set:", this.state.organization_name);
          this.fetchData(this.state.user_id);
          this.applyFiltersFromQueryParams();
        });
      } else {
        console.error("Organization name is missing in URL parameters.");
      }
    });
  }

  fetchData(user_id) {
    const {
      onGetParticipantPayment,
      ongetApprovedLabs,
      ongetcyclelist,
      onGetPendingLabs,
    } = this.props;

    onGetParticipantPayment(user_id);
    console.log("onGetParticipantPayment called with user_id:", user_id);

    ongetApprovedLabs(user_id);
    console.log("ongetApprovedLabs called with user_id:", user_id);

    ongetcyclelist(user_id);
    console.log("ongetcyclelist called with user_id:", user_id);

    onGetPendingLabs(user_id);
    console.log("onGetPendingLabs called with user_id:", user_id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filteredLabs !== this.state.filteredLabs) {
      console.log("FilteredLabs updated:", this.state.filteredLabs);
    }

    if (prevProps.CycleList !== this.props.CycleList) {
      console.log("Updating CycleList in state:", this.props.CycleList);
      this.setState({ CycleList: this.props.CycleList });
    }

    if (prevProps.PaymentSchemeList !== this.props.PaymentSchemeList) {
      this.setState({ PaymentSchemeList: this.props.PaymentSchemeList });
      console.log(
        "PaymentSchemeList prop updated:",
        this.props.PaymentSchemeList
      ); // 👈 NEW
    }

    if (prevProps.AllLabs !== this.props.AllLabs) {
      console.log("Updated AllLabs:", this.props.AllLabs);
      this.setState({ AllLabs: this.props.AllLabs }, () => {
        console.log("State AllLabs updated:", this.state.AllLabs);
        this.applyFilters();
      });
    }

    if (
      prevProps.AllLabs !== this.props.AllLabs ||
      prevProps.CycleList !== this.props.CycleList
    ) {
      console.log("Filtering CycleList for participants");

      const participantSchemes = new Set(
        this.props.AllLabs.flatMap(
          lab => lab.schemes?.map(scheme => scheme.scheme_name) || []
        )
      );

      const filteredCycleList = this.props.CycleList.filter(cycle =>
        participantSchemes.has(cycle.scheme_name)
      );

      this.setState({
        CycleList: this.props.CycleList,
        filteredCycleList,
      });
    }
  }

  openPatientModal = (e, arg) => {
    this.setState({
      PatientModal: true,
      email: arg.email,
      landline_registered_by: arg.landline_registered_by,
    });
  };

  toggleEditModal = (participant = null) => {
    this.setState(
      prev => ({
        editModal: !prev.editModal,
        selectedParticipant: participant || prev.selectedParticipant,
        showModal: participant ? true : !prev.showModal,
      }),
      () => {
        if (!this.state.editModal) {
          this.fetchData(this.state.user_id);
        }
      }
    );
  };

  toggleLabModal = () => {
    this.setState(prevState => ({
      LabModal: !prevState.LabModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };

  toggleModal = () => {
    this.setState(prevState => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  };

  openLabModal = (e, arg) => {
    this.setState({
      LabModal: true,
      email: arg.email,
      shipping_address: arg.shipping_address,
      billing_address: arg.billing_address,
    });
  };

  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };

  togglePatientModal = () => {
    this.setState(prevState => ({
      PatientModal: !prevState.PatientModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };

  openMarketerModal = (e, arg) => {
    this.setState({
      MarketerModal: true,
      marketer_name: arg.marketer_name,
      marketer_phone: arg.marketer_phone,
    });
  };

  toggleMarketerModal = () => {
    this.setState(prevState => ({
      MarketerModal: !prevState.MarketerModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  handleApprovedEvent = id => {
    this.setState({ id: id, isApproved: true, unapprovedModal: true });
  };

  handleUnapprovedEvent = id => {
    this.setState({ id: id, isApproved: false, unapprovedModal: true });
  };

  callOnApproveUnapproveLab = () => {
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;

    const data = {
      id: this.state.user_id,
      labId: this.state.id,
      isApproved: this.state.isApproved,
    };

    onApproveUnapproveLab(data);

    setTimeout(() => {
      onGetPendingLabs(this.state.user_id);
    }, 1000);

    this.setState({ unapprovedModal: false });
  };

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  exportToExcel = () => {
    const { filteredLabs, selectedScheme } = this.state;

    if (!filteredLabs || filteredLabs.length === 0) {
      console.error("No data available to export.");
      alert("No data available to export.");
      return;
    }

    const selectedFields = [
      { key: "name", label: "Name" },
      { key: "email", label: "Email" },
      { key: "address", label: "Address" },
      { key: "shipping_address", label: "Shipping Address" },
      { key: "billing_address", label: "Billing Address" },
      { key: "email_participant", label: "Email of Notification Person" },
      { key: "district", label: "District" },
      { key: "city", label: "City" },
      { key: "lab_staff_name", label: "Name of Notification Person" },
      { key: "designation", label: "Designation" },
      {
        key: "landline_registered_by",
        label: "Contact No of Notification Person",
      },
      { key: "schemes", label: "Schemes" },
      { key: "payment_status", label: "Payment Status" },
      { key: "payment_settlement", label: "Payment Settlement" },
      { key: "membership_status", label: "Membership Status" },
    ];

    const dataToExport = filteredLabs.map(item => {
      const row = {};
      selectedFields.forEach(({ key, label }) => {
        if (key === "schemes") {
          if (Array.isArray(item.schemes)) {
            const uniqueSchemeNames = [
              ...new Set(item.schemes.map(s => s.scheme_name)),
            ];
            row[label] = uniqueSchemeNames.join(", ");
          } else {
            row[label] = "N/A";
          }
        } else {
          row[label] = item[key] || "N/A";
        }
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = { Sheets: { Participants: ws }, SheetNames: ["Participants"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    const [schemeId, cycleId] = (selectedScheme || "").split("-");
    const fileName = schemeId
      ? `Participants_Scheme_${schemeId}_Cycle_${cycleId}.xlsx`
      : "All_Participants.xlsx";

    saveAs(data, fileName);
  };

  getSchemeCounts = () => {
    const { filteredLabs } = this.state;

    const schemeCounts = {};

    filteredLabs.forEach(lab => {
      if (Array.isArray(lab.schemes)) {
        lab.schemes.forEach(scheme => {
          const name = scheme.scheme_name;
          schemeCounts[name] = (schemeCounts[name] || 0) + 1;
        });
      }
    });

    return schemeCounts;
  };

  refreshPage = () => {
    this.fetchData(this.state.user_id);
    this.applyFilters();
  };

  render() {
    console.log("Rendering table with data:", this.state.filteredLabs);
    const { SearchBar } = Search;
    const { ListCity, ListDistrict, ListProvince, ListDesignation } =
      this.state;
    const schemeCounts = this.getSchemeCounts();
    const csrOptions = (this.props.CSRList || []).map(username => ({
      value: username,
      label: username,
    }));
    const cityOptions = ListCity.map(city => ({
      value: city.name,
      label: city.name,
    }));
    const districtOptions = ListDistrict.map(district => ({
      value: district.name,
      label: district.name,
    }));
    const provinceOptions = ListProvince.map(province => ({
      value: province.name,
      label: province.name,
    }));
    const designationOptions = ListDesignation.map(designation => ({
      value: designation.name,
      label: designation.name,
    }));

    const { AllLabs } = this.props;
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;
    const { filteredLabs, selectedParticipantType, selectedScheme } =
      this.state;

    const pageOptions = {
      sizePerPage: 50,
      totalSize: AllLabs.length,
      custom: true,
    };

    const { approvedLabs, CycleList } = this.state;

    const participantOptions = (this.props.approvedLabs || []).map(
      participant => ({
        value: participant.id,
        label: participant.name,
      })
    );

    const schemeOptions = CycleList.filter(
      scheme => scheme.status && scheme.status.toLowerCase() === "active"
    ).map(scheme => ({
      value: `${scheme.scheme_id}-${scheme.id}`,
      label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${scheme.cycle_no})`,
      scheme_id: scheme.scheme_id,
      cycle_id: scheme.id,
      reportstatus: scheme.reportstatus, // ✅ ADD THIS
    }));

    console.log("Mapped scheme option:", schemeOptions);

    const defaultSorted = [{ dataField: "id", order: "desc" }];

    const customStyles = {
      control: provided => ({
        ...provided,
        minHeight: "38px",
      }),
    };
    const schemeColourStyles = {
      option: (styles, { data, isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected
          ? "#0d6efd"
          : isFocused
          ? this.getCycleBgColor(data.reportstatus)
          : this.getCycleBgColor(data.reportstatus),
        color: "#000",
      }),

      multiValue: (styles, { data }) => ({
        ...styles,
        backgroundColor: this.getCycleBgColor(data.reportstatus),
      }),

      multiValueLabel: styles => ({
        ...styles,
        color: "#000",
        fontWeight: 500,
      }),
    };

    return (
      <React.Fragment>
        <div
          className="page-content"
          style={{ width: "80%", margin: "100px auto" }}
        >
          <MetaTags>
            <title>Payment for Participant | Lab Management</title>
          </MetaTags>
          <Container fluid>
            <h2 className="page-title">
              {this.state.selectedParticipant?.name || "Unknown"} - New Payment
            </h2>
            <div className="mt-3 mb-3">
              <Label>Payment Type</Label>
              <Input
                type="select"
                value={this.state.paymentType}
                onChange={e => {
                  const type = e.target.value;
                  this.setState({ paymentType: type });

                  // Redirect to partial payment page if type is partial
                  if (type === "partial") {
                    const participant = this.state.selectedParticipant;

                    this.props.history.push({
                      pathname: `/${this.state.organization_name}/partialpayment2/${participant.id}`,
                      state: { selectedParticipant: participant },
                    });
                  }
                }}
              >
                <option value="new">New Payment</option>
                {/* Only show partial if participant has previous settlement */}
                {this.state.selectedParticipant?.settlementAmount > 0 && (
                  <option value="partial">Partial Payment</option>
                )}
              </Input>
            </div>

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        photo: "",
                        participant: this.state.selectedParticipant?.id || "",
                        paydate: "",
                        payment_status: "",
                        payment_settlement: "",
                        paymentmethod: "",
                        discountAmount: "",
                        taxDeduction: "",
                        scheme: [],
                        part_payment_amount: "",
                        remaining_amount: "",
                        purchase_order_copy: "",
                        price: "",
                        discount: 0,
                        receivedby: "",
                        csrcomments: "",
                        added_by: localStorage.getItem("authUser")
                          ? JSON.parse(localStorage.getItem("authUser")).user_id
                          : "",
                      }}
                      validationSchema={Yup.object().shape({
                        participant: Yup.string().required(
                          "Participant is required"
                        ),
                        taxDeduction: Yup.number().nullable(),
                        discountAmount: Yup.number()
                          .nullable()
                          .transform((value, originalValue) =>
                            originalValue === "" ? null : value
                          ),
                        purchase_order_copy: Yup.mixed().when(
                          "payment_status",
                          {
                            is: val => val !== "Payment In process",
                            then: Yup.mixed().required(
                              "Upload copy of purchase order is required"
                            ),
                            otherwise: Yup.mixed().notRequired(),
                          }
                        ),
                        price: Yup.string().when("discount", {
                          is: discount => discount === 100,
                          then: Yup.string()
                            .test(
                              "price-zero-if-100-discount",
                              "Price must be 0 if discount is 100%",
                              value => parseFloat(value) === 0
                            )
                            .required("Price is required"),
                          otherwise: Yup.string().required("Price is required"),
                        }),
                        payment_status: Yup.string().when(
                          ["discount", "price"],
                          {
                            is: (discount, price) =>
                              !(discount === 100 && parseFloat(price) === 0),
                            then: Yup.string().required(
                              "Payment status is required"
                            ),
                            otherwise: Yup.string().notRequired(),
                          }
                        ),
                        paydate: Yup.string().when(
                          ["discount", "price", "payment_status"],
                          {
                            is: (discount, price, payment_status) =>
                              !(discount === 100 && parseFloat(price) === 0) &&
                              payment_status !== "Payment In process",
                            then: Yup.string().required("Date is required"),
                            otherwise: Yup.string().notRequired(),
                          }
                        ),
                        photo: Yup.mixed().when(
                          ["discount", "price", "payment_status"],
                          {
                            is: (discount, price, payment_status) =>
                              !(discount === 100 && parseFloat(price) === 0) &&
                              payment_status !== "Payment In process",
                            then: Yup.mixed()
                              .required("Deposit Slip is required")
                              .test(
                                "fileSize",
                                "File too large",
                                value =>
                                  !value ||
                                  (value && value.size <= 2 * 1024 * 1024)
                              )
                              .test(
                                "fileType",
                                "Unsupported file format",
                                value =>
                                  !value ||
                                  (value &&
                                    [
                                      "image/jpeg",
                                      "image/png",
                                      "image/jpg",
                                      "application/pdf",
                                    ].includes(value.type))
                              ),
                            otherwise: Yup.mixed().notRequired(),
                          }
                        ),
                        receivedby: Yup.string().when(
                          ["discount", "price", "payment_status"],
                          {
                            is: (discount, price, payment_status) =>
                              !(discount === 100 && parseFloat(price) === 0) &&
                              payment_status !== "Payment In process",
                            then: Yup.string().required(
                              "Received By is required"
                            ),
                            otherwise: Yup.string().notRequired(),
                          }
                        ),
                        paymentmethod: Yup.string().when(
                          ["discount", "price", "payment_status"],
                          {
                            is: (discount, price, payment_status) =>
                              !(discount === 100 && parseFloat(price) === 0) &&
                              payment_status !== "Payment In process",
                            then: Yup.string().required(
                              "Payment Method is required"
                            ),
                            otherwise: Yup.string().notRequired(),
                          }
                        ),
                        purchase_order_copy: Yup.mixed().when(
                          "payment_status",
                          {
                            is: val => val === "Payment In process",
                            then: Yup.mixed().required(
                              "Upload Copy of Purchase Order is required"
                            ),
                            otherwise: Yup.mixed().notRequired(),
                          }
                        ),
                        discount: Yup.number()
                          .nullable()
                          .notRequired()
                          .transform((value, originalValue) =>
                            originalValue === "" ? null : value
                          )
                          .min(-1000, "Discount cannot be less than -1000%")
                          .max(1000, "Discount cannot be more than 1000%"),
                      })}
                      onSubmit={async (
                        values,
                        { setSubmitting, resetForm }
                      ) => {
                        const userId = localStorage.getItem("authUser")
                          ? JSON.parse(localStorage.getItem("authUser")).user_id
                          : "";
                        const roundedPrice = Math.round(
                          parseFloat(values.price)
                        );
                        const safePaydate =
                          values.paydate && values.paydate.trim() !== ""
                            ? values.paydate
                            : null;

                        const AddPayment = {
                          participant: values.participant,
                          scheme: values.scheme,
                          price: roundedPrice,
                          payment_status: values.payment_status,
                          payment_settlement: values.payment_settlement,
                          discount: values.discount,
                          discountAmount: values.discountAmount,
                          paydate: safePaydate,
                          taxDeduction: values.taxDeduction,
                          priceBeforeDiscount: values.priceBeforeDiscount,
                          part_payment_amount: values.part_payment_amount,
                          photo: values.photo,
                          purchase_order_copy: values.purchase_order_copy,
                          receivedby: values.receivedby,
                          paymentmethod: values.paymentmethod,
                          csrcomments: values.csrcomments,
                          added_by: userId,
                        };

                        if (values.discount === 100) {
                          delete AddPayment.remaining_amount;
                          delete AddPayment.paydate;
                          delete AddPayment.photo;
                          delete AddPayment.payment_status;
                          delete AddPayment.receivedby;
                          delete AddPayment.paymentmethod;
                          delete AddPayment.discountAmount;
                          delete AddPayment.payment_settlement;
                        } else {
                          if (values.payment_settlement === "Part") {
                            AddPayment.remaining_amount =
                              values.remaining_amount ?? 0;
                          }
                          AddPayment.paydate = values.paydate ?? null;
                          AddPayment.photo = values.photo ?? null;
                          AddPayment.payment_status =
                            values.payment_status ?? null;
                          AddPayment.receivedby = values.receivedby ?? null;
                          AddPayment.paymentmethod =
                            values.paymentmethod ?? null;
                        }

                        if (values.payment_settlement === "Part") {
                          AddPayment.remaining_amount =
                            values.remaining_amount || 0;
                        }

                        try {
                          await this.props.onAddNewPayment(userId, AddPayment);
                          await this.props.onGetPendingLabs(this.state.user_id);

                          this.setState(
                            {
                              successMessage:
                                "Participant's payment updated successfully",
                            },
                            () => {
                              setTimeout(() => {
                                if (this.successMessageRef) {
                                  this.successMessageRef.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center",
                                  });
                                  this.successMessageRef.setAttribute(
                                    "tabindex",
                                    "-1"
                                  );
                                  this.successMessageRef.focus();
                                } else {
                                  console.warn(
                                    "Success message ref not found — scrolling to top."
                                  );
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                }
                              }, 0);
                            }
                          );

                          if (this.props.onSuccess) {
                            this.props.onSuccess();
                          }

                          setTimeout(() => {
                            this.setState({ successMessage: "" });
                          }, 3000);
                        } catch (error) {
                          console.error("Error adding payment:", error);
                          this.setState(
                            {
                              successMessage:
                                "Failed to save payment. Please try again.",
                            },
                            () => {
                              setTimeout(() => {
                                if (this.successMessageRef) {
                                  this.successMessageRef.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center",
                                  });
                                  this.successMessageRef.setAttribute(
                                    "tabindex",
                                    "-1"
                                  );
                                  this.successMessageRef.focus();
                                } else {
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                }
                              }, 0);
                            }
                          );
                        }

                        // Refresh related data
                        setTimeout(() => {
                          this.props.onGetPendingLabs(this.state.user_id);
                        }, 1000);

                        setTimeout(() => {
                          this.props.ongetcyclelist(this.state.user_id);
                        }, 1000);

                        setSubmitting(false);

                        // ✅ Optional: Reset form so user can enter new payment
                        resetForm();
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        submitForm,
                      }) => (
                        <Form>
                          {this.state.successMessage && (
                            <Alert color="success" className="mb-4">
                              {this.state.successMessage}
                            </Alert>
                          )}

                          <Row>
                            <Col>
                              <Label>Scheme</Label>
                              <Select
                                name="scheme"
                                isMulti
                                options={schemeOptions}
                                styles={schemeColourStyles}
                                className={
                                  errors.scheme && touched.scheme
                                    ? "is-invalid"
                                    : ""
                                }
                                value={schemeOptions.filter(option =>
                                  values.scheme.includes(option.value)
                                )}
                                onChange={selectedOptions => {
                                  const selectedValues = selectedOptions
                                    ? selectedOptions.map(
                                        option => option.value
                                      )
                                    : [];

                                  setFieldValue("scheme", selectedValues);

                                  const totalPrice = selectedValues.reduce(
                                    (sum, combinedId) => {
                                      const [, cycleId] = combinedId
                                        .split("-")
                                        .map(Number);
                                      const scheme = this.props.CycleList.find(
                                        s => s.id === cycleId
                                      );
                                      return (
                                        sum +
                                        (scheme
                                          ? parseFloat(
                                              (scheme.price || "0").replace(
                                                /,/g,
                                                ""
                                              )
                                            )
                                          : 0)
                                      );
                                    },
                                    0
                                  );

                                  setFieldValue(
                                    "priceBeforeDiscount",
                                    totalPrice.toFixed(2)
                                  );
                                  setFieldValue("price", totalPrice.toFixed(2));
                                }}
                              />
                              <ErrorMessage
                                name="scheme"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <div className="mb-3">
                                <Label
                                  htmlFor="priceBeforeDiscount"
                                  className="form-label"
                                >
                                  Payable
                                </Label>
                                <Field name="priceBeforeDiscount">
                                  {({ field }) => (
                                    <input
                                      {...field}
                                      type="text"
                                      className="form-control"
                                      value={new Intl.NumberFormat(
                                        "en-PK"
                                      ).format(values.priceBeforeDiscount || 0)}
                                      readOnly
                                      style={{ backgroundColor: "#e9ecef" }}
                                    />
                                  )}
                                </Field>
                                <ErrorMessage
                                  name="priceBeforeDiscount"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col md={6}>
                              <Label>Discount in (%)</Label>
                              <Field name="discount">
                                {({ field }) => (
                                  <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    onChange={e => {
                                      const discountPercent = parseFloat(
                                        e.target.value
                                      );
                                      setFieldValue("discount", e.target.value);

                                      const payable =
                                        parseFloat(
                                          values.priceBeforeDiscount
                                        ) || 0;
                                      if (!isNaN(discountPercent)) {
                                        const discountAmount =
                                          (payable * discountPercent) / 100;
                                        setFieldValue(
                                          "discountAmount",
                                          discountAmount.toFixed(2)
                                        );
                                        const tax =
                                          parseFloat(values.taxDeduction) || 0;
                                        const finalPrice =
                                          payable - discountAmount - tax;
                                        setFieldValue(
                                          "price",
                                          finalPrice.toFixed(2)
                                        );
                                      }
                                    }}
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="discount"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>

                            <Col md={6}>
                              <Label>Discount Amount (Rs)</Label>
                              <Field name="discountAmount">
                                {({ field }) => (
                                  <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    value={field.value || ""}
                                    onChange={e => {
                                      const discountAmount = parseFloat(
                                        e.target.value
                                      );
                                      setFieldValue(
                                        "discountAmount",
                                        e.target.value
                                      );

                                      const payable =
                                        parseFloat(
                                          values.priceBeforeDiscount
                                        ) || 0;
                                      if (
                                        !isNaN(discountAmount) &&
                                        payable > 0
                                      ) {
                                        const percent =
                                          (discountAmount / payable) * 100;
                                        setFieldValue(
                                          "discount",
                                          percent.toFixed(2)
                                        );
                                        const tax =
                                          parseFloat(values.taxDeduction) || 0;
                                        const finalPrice =
                                          payable - discountAmount - tax;
                                        setFieldValue(
                                          "price",
                                          finalPrice.toFixed(2)
                                        );
                                      }
                                    }}
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="discountAmount"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <Label>Tax Deduction Amount</Label>
                              <Field name="taxDeduction">
                                {({ field }) => (
                                  <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter tax deduction amount"
                                    onChange={e => {
                                      const tax = parseFloat(e.target.value);
                                      setFieldValue(
                                        "taxDeduction",
                                        e.target.value
                                      );

                                      const payable =
                                        parseFloat(
                                          values.priceBeforeDiscount
                                        ) || 0;
                                      const discount =
                                        parseFloat(values.discountAmount) || 0;
                                      if (!isNaN(tax)) {
                                        const finalPrice =
                                          payable - discount - tax;
                                        setFieldValue(
                                          "price",
                                          finalPrice.toFixed(2)
                                        );
                                      }
                                    }}
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="taxDeduction"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <Label>Payment Status</Label>
                              <Select
                                name="payment_status"
                                options={[
                                  { value: "Paid", label: "Paid" },
                                  {
                                    value: "Payment In process",
                                    label: "Payment In process",
                                  },
                                ]}
                                onChange={selectedOption => {
                                  const status = selectedOption?.value || "";
                                  setFieldValue("payment_status", status);
                                  if (
                                    status === "Paid" ||
                                    status === "Payment In process"
                                  ) {
                                    setFieldValue("is_active", true);
                                  }
                                }}
                                value={
                                  values.payment_status
                                    ? {
                                        value: values.payment_status,
                                        label: values.payment_status,
                                      }
                                    : null
                                }
                                placeholder="Select"
                                className={
                                  errors.payment_status &&
                                  touched.payment_status
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              <ErrorMessage
                                name="payment_status"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>

                            {values.payment_status === "Payment In process" && (
                              <Col className="mt-3">
                                <Label>Upload Copy of Purchase Order</Label>
                                <input
                                  type="file"
                                  name="purchase_order_copy"
                                  onChange={event =>
                                    setFieldValue(
                                      "purchase_order_copy",
                                      event.currentTarget.files[0]
                                    )
                                  }
                                  className="form-control"
                                />
                                {errors.purchase_order_copy &&
                                  touched.purchase_order_copy && (
                                    <div className="text-danger mt-1">
                                      {errors.purchase_order_copy}
                                    </div>
                                  )}
                              </Col>
                            )}
                          </Row>

                          {values.payment_status === "Paid" && (
                            <>
                              <Row className="mt-4">
                                <Col>
                                  <div className="mb-3">
                                    <Label
                                      htmlFor="price"
                                      className="form-label"
                                    >
                                      Payable after Discount & Tax Deduction
                                    </Label>
                                    <Field name="price">
                                      {({ field }) => (
                                        <input
                                          {...field}
                                          type="text"
                                          className="form-control"
                                          value={new Intl.NumberFormat(
                                            "en-PK",
                                            {
                                              style: "currency",
                                              currency: "PKR",
                                            }
                                          ).format(values.price || 0)}
                                          readOnly
                                          style={{ backgroundColor: "#e9ecef" }}
                                        />
                                      )}
                                    </Field>
                                    <ErrorMessage
                                      name="price"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mt-3">
                                <Col>
                                  <Label>Payment Settlement</Label>
                                  <Select
                                    name="payment_settlement"
                                    options={[
                                      { value: "Full", label: "Full" },
                                      { value: "Part", label: "Part" },
                                    ]}
                                    onChange={selectedOption => {
                                      const settlement =
                                        selectedOption?.value || "";
                                      setFieldValue(
                                        "payment_settlement",
                                        settlement
                                      );
                                      if (
                                        settlement === "Full" ||
                                        settlement === "Part"
                                      ) {
                                        setFieldValue("is_active", true);
                                      }
                                    }}
                                    value={
                                      values.payment_settlement
                                        ? {
                                            value: values.payment_settlement,
                                            label: values.payment_settlement,
                                          }
                                        : null
                                    }
                                    placeholder="Select"
                                    className={
                                      errors.payment_settlement &&
                                      touched.payment_settlement
                                        ? "is-invalid"
                                        : ""
                                    }
                                  />
                                  <ErrorMessage
                                    name="payment_settlement"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </Col>
                              </Row>

                              {values.payment_settlement === "Part" && (
                                <Row className="mt-3">
                                  <Col md={6}>
                                    <Label>Part Payment Amount</Label>
                                    <Field name="part_payment_amount">
                                      {({ field }) => (
                                        <input
                                          {...field}
                                          type="number"
                                          className={
                                            errors.part_payment_amount &&
                                            touched.part_payment_amount
                                              ? "form-control is-invalid"
                                              : "form-control"
                                          }
                                          value={
                                            field.value === undefined ||
                                            field.value === null
                                              ? ""
                                              : field.value
                                          }
                                          onChange={e => {
                                            const partAmount =
                                              parseFloat(e.target.value) || 0;
                                            const totalAmount =
                                              parseFloat(values.price) || 0;
                                            const remaining =
                                              totalAmount - partAmount;
                                            setFieldValue(
                                              "part_payment_amount",
                                              e.target.value
                                            );
                                            setFieldValue(
                                              "remaining_amount",
                                              remaining >= 0 ? remaining : 0
                                            );
                                          }}
                                        />
                                      )}
                                    </Field>
                                    <ErrorMessage
                                      name="part_payment_amount"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </Col>

                                  <Col md={6}>
                                    <Label>Remaining Amount</Label>
                                    <Field
                                      name="remaining_amount"
                                      type="number"
                                      disabled
                                      className="form-control"
                                    />
                                  </Col>
                                </Row>
                              )}

                              <Row className="mt-3">
                                <Col>
                                  <Label>Pay Date</Label>
                                  <Field
                                    name="paydate"
                                    type="date"
                                    className="form-control"
                                  />
                                  <ErrorMessage
                                    name="paydate"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-3">
                                <Col>
                                  <Label>Pay Copy</Label>
                                  <Input
                                    id="formFile"
                                    name="photo"
                                    type="file"
                                    multiple={false}
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    onChange={event =>
                                      this.handleFileChange(
                                        event,
                                        setFieldValue
                                      )
                                    }
                                    className={
                                      "form-control" +
                                      (errors.photo && touched.photo
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <small style={{ color: "#007bff" }}>
                                    Only JPEG, PNG, or PDF files up to 2MB in
                                    size are allowed.
                                  </small>
                                  <ErrorMessage
                                    name="photo"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-3">
                                <Col>
                                  <Label>Payment Method</Label>
                                  <Select
                                    name="paymentmethod"
                                    options={[
                                      { value: "Online", label: "Online" },
                                      { value: "Cheque", label: "Cheque" },
                                      { value: "Cash", label: "Cash" },
                                    ]}
                                    onChange={selectedOption =>
                                      setFieldValue(
                                        "paymentmethod",
                                        selectedOption?.value || ""
                                      )
                                    }
                                    value={
                                      values.paymentmethod
                                        ? {
                                            value: values.paymentmethod,
                                            label: values.paymentmethod,
                                          }
                                        : null
                                    }
                                    className={
                                      errors.paymentmethod &&
                                      touched.paymentmethod
                                        ? "is-invalid"
                                        : ""
                                    }
                                  />
                                  <ErrorMessage
                                    name="paymentmethod"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </Col>
                              </Row>

                              <Row className="mt-3">
                                <Col>
                                  <Label>Received By</Label>
                                  <Select
                                    name="receivedby"
                                    options={csrOptions}
                                    placeholder="Select CSR"
                                    onChange={selectedOption =>
                                      setFieldValue(
                                        "receivedby",
                                        selectedOption?.value || ""
                                      )
                                    }
                                    value={
                                      values.receivedby
                                        ? {
                                            value: values.receivedby,
                                            label: values.receivedby,
                                          }
                                        : null
                                    }
                                    className={
                                      errors.receivedby && touched.receivedby
                                        ? "is-invalid"
                                        : ""
                                    }
                                  />
                                  <ErrorMessage
                                    name="receivedby"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </Col>
                              </Row>
                              <Row className="mt-3">
                                <Col>
                                  <Label>Comments</Label>
                                  <Field name="csrcomments">
                                    {({ field }) => (
                                      <textarea
                                        {...field}
                                        rows={3}
                                        className={
                                          "form-control" +
                                          (errors.csrcomments &&
                                          touched.csrcomments
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Enter any additional csrcomments"
                                      />
                                    )}
                                  </Field>
                                  <ErrorMessage
                                    name="csrcomments"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </Col>
                              </Row>
                            </>
                          )}

                          <div className="d-flex justify-content-end mt-4">
                            <Button color="primary" type="submit">
                              Save
                            </Button>
                            <Button
                              color="secondary"
                              onClick={() => this.props.history.goBack()}
                              className="ms-2 me-2"
                            >
                              Cancel
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AllParticipantsPaymentPage.propTypes = {
  match: PropTypes.object,
  selectedParticipant: PropTypes.object,
  AllLabs: PropTypes.array,
  className: PropTypes.any,
  onGetPendingLabs: PropTypes.func,
  onApproveUnapproveLab: PropTypes.func,
  history: PropTypes.any,
  onupdateAllLabs: PropTypes.any,
  onAddNewPayment: PropTypes.func,
  onupdateMembershipStatus: PropTypes.func,
  participantId: PropTypes.func,
  ongetApprovedLabs: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  approvedLabs: PropTypes.array,
  onGetParticipantPayment: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  CycleList: PropTypes.array,
  onGetCityList: PropTypes.func,
  onGetDistrictList: PropTypes.func,
  PaymentSchemeList: PropTypes.array,
  isPaymentModalOpen: PropTypes.bool,
  togglePaymentModal: PropTypes.func,
  isMembershipModalOpen: PropTypes.bool,
  toggleMembershipModal: PropTypes.func,
  ListCity: PropTypes.array,
  ListDistrict: PropTypes.array,
  ListProvince: PropTypes.array,
  onGetdesignationlist: PropTypes.func,
  ListDesignation: PropTypes.array,
  onGetProvinceList: PropTypes.func,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  participant: PropTypes.any,
  onClosed: PropTypes.func,
  onSuccess: PropTypes.func,
  CSRList: PropTypes.array,
  location: PropTypes.shape({
    state: PropTypes.shape({
      selectedParticipant: PropTypes.object,
    }),
    search: PropTypes.string,
  }),
};

const mapStateToProps = ({
  Account,
  ListCity,
  ListDistrict,
  ListDesignation,
  ListProvince,
  registrationAdmin,
  CycleList,
  AddPayment, // ← renamed
}) => {
  return {
    userID: Account?.userID || null,
    ListCity: ListCity?.ListCity || [],
    ListDistrict: ListDistrict?.ListDistrict || [],
    ListProvince: ListProvince.ListProvince,
    ListDesignation: ListDesignation.ListDesignation,
    AllLabs: registrationAdmin?.AllLabs || [],
    approvedLabs: registrationAdmin?.approvedLabs || [],
    CycleList: CycleList?.CycleList || [],
    PaymentSchemeList: AddPayment?.PaymentSchemeList || [],
    CSRList: AddPayment?.csr_staff || [],
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  onApproveUnapproveLab: data => dispatch(approveUnapproveLab(data)),
  onGetPendingLabs: id => dispatch(getAllLabs(id)),
  onGetInstrumentTypeList: id => dispatch(getSchemelist(id)),
  onAddNewType: (id, createUnit) => dispatch(addNewSchemeList(id, createUnit)),
  onUpdateType: (id, methodlist) =>
    dispatch(updateSchemeList({ id, ...methodlist })),
  onupdateAllLabs: updatedData => {
    console.log("Dispatching updatedData:", updatedData);
    dispatch(updateAllLabs(updatedData));
  },
  onGetParticipantPayment: id => dispatch(getParticipantSchemelist(id)),
  ongetApprovedLabs: id => dispatch(getApprovedLabs(id)),
  ongetcyclelist: id => dispatch(getcyclelist(id)),
  onAddNewPayment: (id, payment) => dispatch(addNewPayment(id, payment)),
  onupdateMembershipStatus: (id, status) => {
    console.log("Updating Membership Status - ID:", id, "Status:", status);
    dispatch(updateMembershipStatus({ id, ...status }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AllParticipantsPaymentPage));
